import {
  Directive,
  Input,
  ViewContainerRef,
  ComponentRef,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  EnvironmentInjector,
  Type
} from '@angular/core';
import { CustomDynamicComponent } from '../classes-types/dynamic-comp.types';

@Directive({
    selector: '[dynamicComponent]',
    standalone: false
})
export class DynamicComponentDirective implements OnChanges, OnDestroy {

  @Input() desiredComponent!: Type<CustomDynamicComponent>;
  @Input() params: any;

  private componentRef?: ComponentRef<CustomDynamicComponent>;

  constructor(
    private container: ViewContainerRef,
    private envInjector: EnvironmentInjector
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.desiredComponent) {
      return; // 🚨 guard: nothing to create yet
    }

    // If component type changed, recreate
    if (changes['desiredComponent']) {
      this.loadComponent();
    }

    // Update params only
    if (changes['params'] && this.componentRef) {
      Object.assign(this.componentRef.instance, this.params);
    }
  }

  ngOnDestroy(): void {
    this.container.clear();
  }

  private loadComponent(): void {
    this.container.clear();

    console.log(
      'is class:',
      typeof this.desiredComponent === 'function'
    );
    this.componentRef = this.container.createComponent(
      this.desiredComponent
    );

    if (this.params) {
      Object.assign(this.componentRef.instance, this.params);
    }
  }
}
